import { render, staticRenderFns } from "./partnerAdd.vue?vue&type=template&id=f9ab79d8&scoped=true&"
import script from "./partnerAdd.vue?vue&type=script&lang=js&"
export * from "./partnerAdd.vue?vue&type=script&lang=js&"
import style0 from "./partnerAdd.vue?vue&type=style&index=0&id=f9ab79d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ab79d8",
  null
  
)

export default component.exports